import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconPlaceholder: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconPlaceholder"><Path d="M3.5 6V3.5H6M18 3.5H20.5V6M20.5 18V20.5H18M6 20.5H3.5V18M3.5 14V10M10 3.5H14M20.5 10V14M14 20.5H10" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconPlaceholder;
